export var getTotalSum = array => {
  return array === null || array === void 0 ? void 0 : array.reduce((acc, curr) => acc + parseInt(curr.number), 0);
};
export var getPercentage = (array, number) => {
  var totalSum = getTotalSum(array);
  return (number / totalSum * 100).toFixed(2);
};
export var formatNumber = num => {
  if (num < 1000000) return num.toString();
  return (num / 1000000).toFixed(1) + 'M';
};